module.exports = __webpack_public_path__ + "img/boston-b-white.f990d23b.png";